import i18n from '../../../../../i18n'

import iconFbPixel from '../i/fbPixel.png'
import iconGa from '../i/ga.png'
import iconEmail from '../i/mail.png'
import iconHs from '../i/hs.png'
import iconSf from '../i/sf.png'
import iconMt from '../i/marketo.png'

export const INTEGRATION_IDS = {
    ga: 'ga',
    fb_p: 'fb_p',
    email: 'email',
    hs: 'hs',
    sf: 'sf',
    mt: 'mt',
}

export const INTEGRATIONS_MAP = {
    [INTEGRATION_IDS.ga]: {
        id: INTEGRATION_IDS.ga,
        name: i18n.t('Google Analytics'),
        description: i18n.t('Connect Google Analytics ID to collect statistics'),
        image: iconGa,
        isChecked: false,
        isDisabled: false,
        settings: {
            id: '',
        },
    },
    [INTEGRATION_IDS.email]: {
        id: INTEGRATION_IDS.email,
        name: i18n.t('Email'),
        description: i18n.t('Receive in the mail all the necessary information about the activities in your projects'),
        image: iconEmail,
        isChecked: false,
        isDisabled: false,
        settings: {
            email: '',
        },
    },
    [INTEGRATION_IDS.fb_p]: {
        id: INTEGRATION_IDS.fb_p,
        name: i18n.t('Facebook pixel'),
        description: '',
        image: iconFbPixel,
        isChecked: false,
        isDisabled: true,
        settings: {},
    },
    [INTEGRATION_IDS.hs]: {
        id: INTEGRATION_IDS.hs,
        name: i18n.t('HubSpot'),
        description: '',
        image: iconHs,
        isChecked: false,
        isDisabled: true,
        settings: {},
    },
    [INTEGRATION_IDS.sf]: {
        id: INTEGRATION_IDS.sf,
        name: i18n.t('salesforce'),
        description: '',
        image: iconSf,
        isChecked: false,
        isDisabled: true,
        settings: {},
    },
    [INTEGRATION_IDS.mt]: {
        id: INTEGRATION_IDS.mt,
        name: i18n.t('Marketo'),
        description: '',
        image: iconMt,
        isChecked: false,
        isDisabled: true,
        settings: {},
    },
}
